<template>
  <div class="flex flex-col w-full max-w-md gap-5 mx-auto lg:gap-10">
    <slot></slot>
  </div>
</template>
